import { AdvertiserModel } from '@/models/Advertiser'

const getters = {
  currentAdvertiser(state) {
    if (state.currentAdvertiser instanceof AdvertiserModel === false) {
      return null
    }
    return state.currentAdvertiser
  },
  currentAdvertiserName(state) {
    if (state.currentAdvertiser instanceof AdvertiserModel === false) {
      return ''
    }
    return state.currentAdvertiser.name
  },
  currentAdvertiserId(state) {
    if (state.currentAdvertiser instanceof AdvertiserModel === false) {
      return ''
    }
    return state.currentAdvertiser.id
  },
}

export default getters
